import {
  setSkills,
  getSkills,
  getEquipment,
  addEquip,
  getItems,
} from '../../utils/api/index';
import templateJerseys from './templates/jerseys';
import templateSkills from './templates/skills';
import checkMetamask from '../../utils/checkMetamask';
import showAlert from '../../utils/showAlert';
import login from '../../utils/login';
import { getToken } from '../../utils/login';

const initPlayerDetail = async () => {
  const element = $('.js-detail-player-info');
  if (!element.length) {
    return;
  }

  // if (!await checkMetamask()) {
  //   return;
  // }
  //
  // if (!await login()) {
  //   return;
  // }

  // const sessionKey = window.sessionStorage.getItem('sessionKey');
  const token = getToken();

  const { jerseys, success, shoes } = await getItems({
    data: {
      token,
    },
  });

  const { details } = await getEquipment({
    data: {
      nft_id: window.nft_id,
      generation: window.generation,
      token,
    },
  });

  const { skills, available } = await getSkills({
    data: {
      nft_id: window.nft_id,
      token,
      generation: window.generation,
    },
  });

  // const accounts = await web3Client.eth.getAccounts();
  // const ownerElements = $('.owner-of');
  $('.js-center-area').html(templateSkills({
    skills,
    available,
    skillVisible: true, // fixme
  }));

  $('.js-tab-toggle').on('click', (e) => {
    e.preventDefault();
    const target = $(e.currentTarget).attr('target');
    $('.js-tab-toggle').removeClass('active');
    $(e.currentTarget).addClass('active');
    $('.js-tabs').removeClass('d-block').addClass('d-none');
    $(target).removeClass('d-none').addClass('d-block');
  });
  $('.js-detail-items').removeClass('d-none').find('.js-content').html(templateJerseys(jerseys, details, shoes));

  if (success) {
    $('.js-add-jersey').on('click', async (e) => {
      const $that = $(e.currentTarget);
      const data = {
        nft_id: window.nft_id,
        generation: window.generation,
        operation: 'add',
        jersey_id: $that.data('jersey_id'),
        token,
      };

      const res = await addEquip({
        data,
      });

      if (!res.success) {
        showAlert({ message: res.message, icon: 'error' });
      } else {
        window.location.reload();
      }
    });

    $('.js-remove-jersey').on('click', async (e) => {
      const $that = $(e.currentTarget);
      const data = {
        nft_id: window.nft_id,
        generation: window.generation,
        operation: 'remove',
        jersey_id: $that.data('jersey_id'),
        token,
      };

      const res = await addEquip({
        data,
      });

      if (!res.success) {
        showAlert({ message: res.message, icon: 'error' });
      } else {
        window.location.reload();
      }
    });

    $('.js-add-shoe').on('click', async (e) => {
      const $that = $(e.currentTarget);
      const data = {
        nft_id: window.nft_id,
        generation: window.generation,
        operation: 'add',
        shoe_id: $that.data('shoe_id'),
        token,
      };

      const res = await addEquip({
        data,
      });

      if (!res.success) {
        showAlert({ message: res.message, icon: 'error' });
      } else {
        window.location.reload();
      }
    });

    $('.js-remove-shoe').on('click', async (e) => {
      const $that = $(e.currentTarget);
      const shoe_id = $that.data('shoe_id');

      const res = await addEquip({
        data: {
          nft_id: window.nft_id,
          generation: window.generation,
          operation: 'remove',
          shoe_id,
          token,
        },
      });

      if (!res.success) {
        showAlert({ message: res.message, icon: 'error' });
      } else {
        window.location.reload();
      }
    });

    const upgrade = {};
    const puan = {};

    const getAvaliblePuan = () => Object.values(puan).reduce((a, b) => a + b, 0);

    const checkNextStep = () => {
      skills.forEach((element) => {
        const $element = $(`[data-name="${element.name}"]`);
        const current = Number($element.data('new-current') || element.current);
        const n = Number(element.points[Number(current)]);

        console.log(current, n, puan, upgrade);

        if (available < getAvaliblePuan() + n) {
          $element.find('.js-skill-up').attr('disabled', 'disabled');
        } else {
          $element.find('.js-skill-up').removeAttr('disabled');
        }

        if (current - 1 < element.current) {
          $element.find('.js-skill-down').attr('disabled', 'disabled');
        }
      });
    };

    $('.js-skill-up').on('click', (e) => {
      const $that = $(e.currentTarget);
      const $skill = $that.closest('.js-skill-item');
      const name = $skill.data('name');
      const skill = skills.find(item => item.name === name);
      const newCurrent = Number($skill.data('new-current') || skill.current);
      const necessary = skill.points[(newCurrent)];

      if (typeof puan[name] === 'undefined') {
        puan[name] = 0;
      }

      $skill.find('.skills-item__score span.current').addClass('changed');
      $skill.find('.skills-item__score span.required-point').text(skill.points[(newCurrent + 1)]);
      $skill.find('.skills-item__score span.current').text(1 + newCurrent);

      if (available >= getAvaliblePuan() + Number(necessary)) {
        puan[name] += Number(necessary);
        upgrade[name] = (newCurrent + 1);
        $skill.data('new-current', newCurrent + 1);
        $skill.find('.js-skill-down').removeAttr('disabled');

        $skill.find('.js-skil-upgrade').css({
          width: `${newCurrent + 1}%`,
        });
      } else {
        showAlert({ title: 'Warning', message: 'you have exceeded available points' });
      }

      checkNextStep();
    });

    $('.js-skill-down').on('click', (e) => {
      const $that = $(e.currentTarget);
      const $skill = $that.closest('.js-skill-item');
      const name = $skill.data('name');
      const skill = skills.find(item => item.name === name);
      const newCurrent = Number($skill.data('new-current') || skill.current);

      $skill.find('.skills-item__score span.required-point').text(skill.points[(newCurrent - 1)]);
      $skill.find('.skills-item__score span.current').text(newCurrent - 1);

      if (upgrade[name]) {
        puan[name] -= Number(skill.points[newCurrent - 1]);
        upgrade[name] = (newCurrent - 1);
        if (puan[name] === 0) {
          $that.attr('disabled', 'disabled');
        }
        $skill.data('new-current', newCurrent - 1);
        $skill.find('.js-skil-upgrade').css({
          width: `${newCurrent - 1}%`,
        });
      }

      checkNextStep();
    });

    $('.js-set-skills').on('click', async (e) => {
      e.preventDefault();

      const res = await setSkills({
        data: {
          nft_id: window.nft_id,
          generation: window.generation,
          token,
          ...upgrade,
        },
      });

      if (!res.success) {
        showAlert({ message: res.message, icon: 'error' });
      } else {
        window.location.reload();
      }
    });
  }
};

export default initPlayerDetail;
